import HttpError from './HttpError';

export interface IExecuteRequestConfig {
  responseType?: 'arrayBuffer' | 'blob' | 'formData' | 'json' | 'text';
  errorType?: 'arrayBuffer' | 'blob' | 'formData' | 'json' | 'text';
}

export default async function executeRequest(request: Request, { responseType = 'json', errorType = 'json' }: IExecuteRequestConfig = {}) {
  const referenceError = new Error();

  const response = await fetch(request);

  if (!response.ok) {
    throw new HttpError(response, {
      cause: referenceError,
      stack: [new Error().stack, `CAUSE: ${referenceError.stack}`].join('\n'),
      data: await response[errorType](),
    });
  }

  //no content
  if (response.status === 204) {
    return Promise.resolve();
  }

  switch (responseType) {
    case 'arrayBuffer':
      return response.arrayBuffer();
    case 'blob':
      return response.blob();
    case 'formData':
      return response.formData();
    case 'json':
      return response.json();
    case 'text':
      return response.text();

    default:
      return response;
  }
}
